import moment from "moment-timezone";
import { cn } from "@/lib/utils";
import { ChatImagePreview } from "./ChatImagePreview";
import type { ChatViewMessage } from "./types";

const CommonDestinationTimezone = "America/Chicago";

interface ChatBubbleProps {
  message: ChatViewMessage;
}

export function ChatBubble({ message }: ChatBubbleProps) {
  const isRight = message.side === "right";

  const formattedTime = moment
    .tz(message.timestamp, CommonDestinationTimezone)
    .format("MMM D, YYYY h:mm A");

  return (
    <div
      className={cn(
        "flex flex-col max-w-[85%] md:max-w-[70%] gap-0.5",
        isRight ? "self-end items-end" : "self-start items-start"
      )}
    >
      {/* Sender label */}
      <div className="flex items-center gap-1.5 px-1">
        <span className="text-xs font-medium text-muted-foreground truncate max-w-[200px]">
          {message.label}
        </span>
        {message.secondaryLabel && (
          <>
            <span className="text-xs text-muted-foreground">·</span>
            <span className="text-xs text-muted-foreground truncate max-w-[200px]">
              {message.secondaryLabel}
            </span>
          </>
        )}
      </div>

      {/* Bubble */}
      <div
        className={cn(
          "rounded-xl px-3 py-2 text-sm break-words",
          isRight
            ? "bg-primary text-primary-foreground rounded-tr-sm"
            : "bg-muted rounded-tl-sm"
        )}
      >
        {message.imageUrl && (
          <ChatImagePreview src={message.imageUrl} />
        )}
        {message.body && (
          <p className={cn(message.imageUrl ? "mt-2" : "")}>
            {message.body}
          </p>
        )}
        {!message.body && !message.imageUrl && (
          <p className="italic text-muted-foreground text-xs">
            [empty message]
          </p>
        )}
      </div>

      {/* Timestamp */}
      <span className="text-[10px] text-muted-foreground px-1">
        {formattedTime}
      </span>
    </div>
  );
}
